var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon_valid)?_c('div',{staticClass:"triumph-icon",style:(_vm.offset_style),attrs:{"title":_vm.icon.name}}):_c('div',{staticClass:"triumph-icon"})
}
var staticRenderFns = []

export { render, staticRenderFns }